"use client";

import { basePrayerSchema } from "../../../../lib/types/schema/prayer/basePrayerSchema";
import type { UseRequestProps } from "../../../../request/hooks/useRequest";
import { useRequest } from "../../../../request/hooks/useRequest";

export type UseRequestCollectionNextUpProps = UseRequestProps;

export const useRequestCollectionNextUp = ({
  ...props
}: UseRequestCollectionNextUpProps = {}) => ({
  requestGet: useRequest({
    ...props,
    fnRequestProps: ({ id }: { id: number }) => ({
      schema: basePrayerSchema,
      urlBackendPath: `/collections/${id}/nextup`,
    }),
  }),
});
